import type { MasterFieldDef } from './masters/types';

/** Swiggy/Zomato-style image specs for food delivery masters */
export const FOOD_IMAGE_SPECS = {
  restaurantType: { minWidth: 400, minHeight: 300, maxWidth: 2000, maxHeight: 1500, aspectRatio: '4:3' },
  category: { minWidth: 400, minHeight: 400, maxWidth: 1200, maxHeight: 1200, aspectRatio: '1:1' },
  cuisine: { minWidth: 512, minHeight: 512, maxWidth: 1200, maxHeight: 1200, aspectRatio: '1:1' },
  addon: { minWidth: 200, minHeight: 200, maxWidth: 800, maxHeight: 800, aspectRatio: '1:1' },
  thumbnail: { minWidth: 400, minHeight: 400, maxWidth: 800, maxHeight: 800, aspectRatio: '1:1' },
  gallery: { minWidth: 1200, minHeight: 800, maxWidth: 2400, maxHeight: 1600, aspectRatio: '3:2' },
  dietaryIcon: { minWidth: 64, minHeight: 64, maxWidth: 256, maxHeight: 256, aspectRatio: '1:1' },
} as const;

type ImageSpec = typeof FOOD_IMAGE_SPECS[keyof typeof FOOD_IMAGE_SPECS];

function imageField(
  key: string,
  label: string,
  spec: ImageSpec,
  extra?: Partial<MasterFieldDef>,
): MasterFieldDef {
  return {
    key,
    label,
    type: 'image',
    required: extra?.required,
    imageMinWidth: spec.minWidth,
    imageMinHeight: spec.minHeight,
    imageMaxWidth: spec.maxWidth,
    imageMaxHeight: spec.maxHeight,
    imageAspectRatio: spec.aspectRatio,
    helperText: `Recommended ${spec.minWidth}×${spec.minHeight}px (${spec.aspectRatio}). Max ${spec.maxWidth}×${spec.maxHeight}px.`,
    ...extra,
  };
}

export const foodImageFields = {
  restaurantType: () => imageField('imageUrl', 'Cover Image', FOOD_IMAGE_SPECS.restaurantType, { required: true }),
  category: () => imageField('imageUrl', 'Category Image', FOOD_IMAGE_SPECS.category, { required: true }),
  cuisine: () => imageField('imageUrl', 'Cuisine Image', FOOD_IMAGE_SPECS.cuisine, { required: true }),
  addon: () => imageField('imageUrl', 'Addon Image', FOOD_IMAGE_SPECS.addon),
  thumbnail: () => imageField('imageUrl', 'Thumbnail', FOOD_IMAGE_SPECS.thumbnail, { required: true }),
  gallery: () => imageField('imageUrl', 'Gallery Image', FOOD_IMAGE_SPECS.gallery, { required: true }),
  dietaryIcon: () => imageField('icon', 'Dietary Icon', FOOD_IMAGE_SPECS.dietaryIcon),
};

export const TIME_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;
export const PHONE_PATTERN = /^\+?\d{8,15}$/;
